import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { cumulativeReportEntrypoint } from '@atlassian/jira-spa-apps-next-gen-reports-cumulative/entrypoint.tsx';

export const CumulativeReportPageEntrypoint = createPageEntryPoint({
	main: cumulativeReportEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
